import React, { useState, useRef, useEffect } from 'react';
import './home.css';
import { Link } from 'react-router-dom';
import supremeBotScreenshot from './supremebotscreenshot.jpg';

function Home() {
  const [isHovered, setIsHovered] = useState(false); // Add state for hover effect
  const featuresRef = useRef(null);

  const scrollToFeatures = () => {
    if (featuresRef.current) {
      featuresRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const homeContainer = document.querySelector('.home-container');
    if (homeContainer) {
      homeContainer.style.paddingTop = '80px';
    }
  },);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div className="home-container">
            <div className="initial-section">
                <div className="left-column">
                    <h1 className="bot-title">The FASTEST Supreme & Nike Bot EVER</h1>
                    <p className="bot-description">
                        Tired of missing out on hyped Supreme or Nike releases? Our applications make purchasing EASY with our keyword finder, add to cart, and complete checkout.
                    </p>
                    <div className="button-group">
                        <Link to="/login">
                            <button className="get-access-button">GET ACCESS</button>
                        </Link>
                        <button className="learn-more-button" onClick={scrollToFeatures}>
                            Learn More
                        </button>
                    </div>
                    <div className="user-count">
                        Join 100+ Users
                    </div>
                </div>
                <div className="right-column">
                    <img
                    src={supremeBotScreenshot}
                    alt="Bot Interface"
                    className="bot-interface-image"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    style={{
                        transform: isHovered ? 'translateX(10px)' : 'none', // Move 10px to the right
                        transition: 'transform 0.3s ease',
                    }}
                    />
                </div>
            </div>

            <div className="features-section" ref={featuresRef} id="features">
                <h2>Extensive Task Options & Bot Features</h2>
                <p>We give users full control when setting up their tasks, highly customizable and easy to use.</p>
                <div className="features-grid">
                    <div className="feature-item">
                        <strong>Keyword Finder</strong>
                        <p>Search for products by keyword.</p>
                    </div>
                    <div className="feature-item">
                        <strong>Variant Selection</strong>
                        <p>Get specific by selecting a variant (color, edition, etc).</p>
                    </div>
                    <div className="feature-item">
                        <strong>Size Selection</strong>
                        <p>With optional fallback to any size.</p>
                    </div>
                    <div className="feature-item">
                        <strong>Automated Checkout</strong>
                        <p>Eliminate manual checkout hassles. Handles checkout in seconds.</p>
                    </div>
                    <div className="feature-item">
                        <strong>Windows Support</strong>
                        <p>Download and run our powerful bot directly on Windows. macOS and Linux support coming soon!</p>
                    </div>
                    <div className="feature-item">
                        <strong>Fast and Efficient</strong>
                        <p>Uses Google Chrome to quickly navigate websites and complete purchases.</p>
                    </div>
                    <div className="feature-item">
                        <strong>Card Information Security</strong>
                        <p>We do not store any credit card information. Your data is processed securely and directly through Stripe's secure payment gateways.</p>
                    </div>
                    <div className="feature-item">
                        <strong>24/7 Availability</strong>
                        <p>Our automated bot works around the clock.</p>
                    </div>
                    <div className="feature-item">
                        <strong>Secure Payment Processing</strong>
                        <p>Securely automates payment details.</p>
                    </div>
                    <div className="feature-item">
                        <strong>Saves Time and Effort</strong>
                        <p>Reclaim your time and focus on other things.</p>
                    </div>
                    <div className="feature-item">
                        <strong>User-Friendly Interface</strong>
                        <p>Simple and intuitive setup, easy to use.</p>
                    </div>
                    <div className="feature-item">
                        <strong>And Much More!</strong>
                        <p>Explore the full range of features.</p>
                    </div>
                </div>
            </div>

            <div className="pricing-section">
                <h2>Get Access Today</h2>
                <div className="pricing-grid">
                    <div className="pricing-card">
                        <h3>One-Time Payment</h3>
                        <p className="price">$10</p>
                        <p className="description">Life-Time Access</p>
                        <ul style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <li>Instant Access</li>
                            <li>Unlimited Supreme & Nike Drops</li>
                            <li>Email Support</li>
                        </ul>
                        <Link to="/register" className="purchase-button">Purchase Now</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;